import { useLocation } from '@gatsbyjs/reach-router'
import React from 'react'

import withDispensaryAccount, {
  WithDispensaryAccountFC,
} from '../../../../../hoc/withDispensaryAccount'
import { getDispensaryBasePath } from '../../../../../lib/dispensaries'
import { rewardsSourceDispensary } from '../../../../../lib/rewards/sources'
import ClickToCopy from '../../../../global/ClickToCopy'
import Spacer from '../../../../Spacer'
import { DeactivateDispensaryMessage } from './messages/DeactivateDispensaryMessage'
import { DispensaryNotifications } from './messages/DispensaryNotifications'
import RecentRewardsOrdersContainer from './RecentRewardsOrdersContainer'
import { StyledHeader, StyledSmallHeader } from './styled'

export interface DispensaryDashboardProps {
  className?: string
}

const DispensaryDashboard: WithDispensaryAccountFC<DispensaryDashboardProps> = ({
  settings,
  dispensary,
}) => {
  const location = useLocation()

  const dispensaryLink = `${
    location?.origin ?? 'https://www.designsforhealth.com'
  }${getDispensaryBasePath(dispensary.slug)}`

  return (
    <>
      <StyledHeader>Virtual Dispensary</StyledHeader>
      <DispensaryNotifications settings={settings} />
      <StyledSmallHeader>Share this link with your patients:</StyledSmallHeader>
      <ClickToCopy copyText={dispensaryLink} />
      <Spacer size={4} />
      <RecentRewardsOrdersContainer rewardsSource={rewardsSourceDispensary} />
      <Spacer size={4} />
      <DeactivateDispensaryMessage />
    </>
  )
}

export default withDispensaryAccount(DispensaryDashboard)
